<!-- App.svelte -->

<script>
  import { Router, Route } from "svelte-routing";
  import Navbar from "./Navbar.svelte";
  import Home from "./Home.svelte";
  import Home1 from "./home1.svelte";
  import About from "./About.svelte";
  import Service from "./Service.svelte";
  import Software from "./Software.svelte";
  import Contact from "./Contact.svelte";
  import web from "./Web.svelte";
  import mobileapp from "./Mobileapp.svelte";
  import blockchain from "./Blockchain.svelte";
  import game from "./Game.svelte";
</script>

<Router>
  <Navbar />
  <Route path="/home" component={Home} />
  <Route path="/about" component={About} />
  <Route path="/" component={Home1} />
  <Route path="/service" component={Service} />
  <Route path="/software" component={Software} />
  <Route path="/game" component={game} />
  <Route path="/blockchain" component={blockchain} />
  <Route path="/mobileapp" component={mobileapp} />
  <Route path="/web" component={web} />
  <Route path="/contact" component={Contact} />
</Router>

<style>
  /* Your styles here */
</style>
